import { fetch } from '../../api';
import { fetchData } from './dataActionsCreator';

function formatContextUser(user) {
  // a lot of values from payload.context.user is not populated from the b/e and is equal to zero
  // the store will be updated wrongly if we don't filter them out
  // so we're keeping only the basic group data
  const groups = user.groups.map(group => ({
    id: group.id,
    groupCode: group.groupCode,
    imageUrl: group.imageUrl,
  }));

  return {
    unverifiedEmail: '',
    ...user,
    groups,
  };
}

export async function fetchContextData(url) {
  const { payload } = await fetch('context', { query: { url } });
  const contextUser = formatContextUser(payload.context.user);
  const users = [...(payload.users || {}), contextUser, payload.user].filter(u => !!u);
  const groups = [...(payload.groups || {}), payload.group].filter(g => !!g);

  return { users, groups };
}

export default function fetchContext(url) {
  return fetchData(() => fetchContextData(url));
}



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/contextActionsCreator.js